import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoughShared = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M27.5 5H16.11L5 20l7.5 23h16.595v-3H15L8.5 20.5l9-12.5H26l10.73 15.715h3.662z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M48 43H32v-.95q0-2.1 2.125-3.425T40 37.3t5.875 1.325T48 42.05zM42.575 33.229Q41.5 34.3 39.996 34.3t-2.575-1.075-1.071-2.579 1.075-2.575T40.004 27t2.575 1.075 1.071 2.579-1.075 2.575" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "m9.757 28.04 24.464-10.462.393.92L10.15 28.96z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M12.919 12.158 23.38 22.81l-.713.7-10.463-10.65z"
		})
	]
});
export default SvgRoughShared;
